module.exports = __webpack_public_path__ + "static/media/krungtep.bae5537f.png";